import { Link } from "react-router-dom";
import { latestList, hotList } from "../../../mocks/news";
import { CoverCard, ListRow } from "../../../components/base/NewsCard";
import SectionTitle from "../../../components/base/SectionTitle";

export default function LatestFeed() {
  const feed = latestList.slice(0, 6);
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
        {/* 最新动态 */}
        <div className="lg:col-span-2">
          <SectionTitle eyebrow title="最新动态" to="/category/wanghong" linkLabel="更多快讯" />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {feed.map((item) => (
              <CoverCard key={item.slug} item={item} />
            ))}
          </div>
        </div>

        {/* 侧栏 */}
        <aside className="space-y-6 lg:sticky lg:top-24 lg:self-start">
          <div className="rounded-xl border border-background-200 bg-background-50 p-5">
            <h3 className="flex items-center gap-2 font-serif text-lg font-black text-foreground-950">
              <i className="ri-fire-fill text-primary-500" /> 全网热榜
            </h3>
            <p className="mt-1 text-xs text-foreground-500">按热度实时更新的 TOP 榜单</p>
            <div className="mt-3 divide-y divide-background-200">
              {hotList.map((a, i) => (
                <ListRow key={a.slug} item={a} index={i} />
              ))}
            </div>
          </div>

          <div className="overflow-hidden rounded-xl bg-secondary-800 p-5 text-background-100">
            <h3 className="flex items-center gap-2 font-serif text-lg font-black text-accent-300">
              <i className="ri-megaphone-fill" /> 线索征集
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-background-200">
              手握独家猛料或行业线索？欢迎投稿，我们会在核实后第一时间跟进报道。
            </p>
            <Link
              to="/faq#tougao"
              className="mt-4 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-accent-400 px-4 py-2 text-sm font-medium text-secondary-900 transition-colors hover:bg-accent-300"
            >
              我要投稿 <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}